import 'bootstrap/dist/css/bootstrap.min.css';
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { LocationProvider } from './LocationContext'; // Import the LocationProvider
import { useEffect } from 'react';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getDatabase, ref, onDisconnect, set } from "firebase/database";
import { app } from './firebase.js';
import Login from './Pages/Login.js';
import Recoverpass from './Pages/Recoverpass.js';
import './App.css';
import './dash.css';
import './ResponsiveDash.css';
import './Respdesign.css';

// Instructor Account
import DashboardIn from './Instructor/DashboardIn';
import MyClasses from './Instructor/MyClasses';
import Students from './Instructor/Students';
import MyChannels from './Instructor/MyChannels';
import Workshops from './Instructor/Workshops';
import ClientProjo from './Instructor/Clientprojects';
import Studentsreposts from './Instructor/Studentsreposts';
import MyThoughts from './Instructor/MyThoughts';
import AiAssistantIn from './Instructor/AiAssistant';
import ProfileIn from './Instructor/Profile';
import Updateaccount from './Instructor/Updateaccount';
import AllCalls from './Instructor/AllCalls';
import Chat from './Instructor/Chat.js';

function App() {

  const auth = getAuth();

  useEffect(() => {
    const db = getDatabase(app);
    // Listen for changes in authentication state
    onAuthStateChanged(auth, (user) => {
      if (user) {
        const userId = user.uid;
        const userStatusRef = ref(db, `/status/${userId}`);

        // User is online
        const onlineStatus = {
          state: "online",
          last_changed: Date.now(),
          userId:userId
        };

        const offlineStatus = {
          state: "offline",
          last_changed: Date.now(),
          userId:userId
        };

        // Set user as online when connected
        set(userStatusRef, onlineStatus);

        // Set user as offline automatically when disconnected
        onDisconnect(userStatusRef).set(offlineStatus);
      }
    });
  }, [auth]);


  return (
    <div className="App">
      <LocationProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/recover" element={<Recoverpass />} />

              {/* INSTRUCTOR ACCOUNT*/}
              <Route path="dashboard" element={<DashboardIn />} />
              <Route path="my-classes" element={<MyClasses />} />
              <Route path="students" element={<Students />} />
              <Route path="channels" element={<MyChannels />} />
              <Route path="workshops" element={<Workshops />} />
              <Route path="assigned-profects" element={<ClientProjo />} />
              <Route path="students-reports" element={<Studentsreposts />} />
              <Route path="my-thoughts" element={<MyThoughts />} />
              <Route path="ai-assistant" element={<AiAssistantIn />} />
              <Route path="profile" element={<ProfileIn />} />
              <Route path="edit-profile" element={<Updateaccount />} />
              <Route path="class-session" element={<AllCalls />} />
              <Route path="chat" element={<Chat />} />
            </Routes>       
          </BrowserRouter>    
        </LocationProvider> 
    </div>
  );
}

export default App;
